// extracted by mini-css-extract-plugin
export default {"registerKey":"RegisterKey_registerKey__oIm1v","registerKey__button":"RegisterKey_registerKey__button__o0FFD","registerKey__select":"RegisterKey_registerKey__select__TyKT2"};